import React, { Component } from "react";
import { Link } from "react-router-dom";
import { CardElement, injectStripe } from "react-stripe-elements";
import { observer, inject } from "mobx-react";
import Http from "axios";
import config from "../config";

@inject("CartStore", "UserStore")
@observer
class CheckoutForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      submitted: false,
      disabledInputs: false,
      error: false,
      address1: "",
      address2: "",
      phone: "",
      pickUp: true,
      pickUpLocation: "",
      pickUpTime: "",
      date: null,
      focused: false,
      activeTab: "pickup"
    };
  }

  handleSubmit(e) {
    e.preventDefault();

    // Show a loading screen...
    this.setState({
      submitting: true
    });

    // Disable all inputs.
    this.setState({
      disabledInputs: true,
      error: false
    });

    // Use Stripe.js to create a token. We only need to pass in one Element
    // from the Element group in order to create a token. We can also pass
    // in the additional customer data we collected in our form.

    this.props.stripe
      .createToken({
        name:
          this.props.UserStore.user.firstName +
          " " +
          this.props.UserStore.user.lastName,
        address1: this.state.address1,
        address2: this.state.address2,
        phone: this.state.phone
      })
      .then(({ token, error }) => {
        if (!token) {
          this.setState({
            submitted: false,
            submitting: false,
            error: error.message
          });
          return;
        }

        console.log(token);

        const {
          pickUp,
          pickUpLocation,
          phone,
          address1,
          address2,
          pickUpTime,
          date
        } = this.state;
        const {
          UserStore,
          downloadMode,
          CartStore,
          targetProduct,
          toggleModal
        } = this.props;
        const { user } = UserStore;

        return Http.post(
          config.api + "/checkout",
          {
            info:
              pickUp && !downloadMode
                ? {
                    address1: pickUpLocation,
                    phone,
                    pickedUp: pickUp,
                    pickUpTime
                  }
                : {
                    address1:
                      address1 ||
                      (user && user.addresses ? user.addresses.address1 : ""),
                    address2:
                      address2 ||
                      (user && user.addresses ? user.addresses.address2 : ""),
                    phone,
                    pickedUp: pickUp,
                    pickUpTime
                  },

            paymentToken: token.id,
            products: !downloadMode ? CartStore.items : [targetProduct],
            product: targetProduct,
            startDate: date ? date.toISOString() : null
          },

          {
            withCredentials: true
          }
        )
          .then(checkout => {
            this.setState({
              submitted: true,
              submitting: false
            });
            CartStore.resetCart();

            if (!downloadMode) {
              setTimeout(
                () => {
                  this.setState({
                    submitted: false,
                    submitting: false
                  });
                  toggleModal();
                },

                4000
              );
            }
          })
          .catch(err => {
            console.error(err);

            this.setState({
              submitted: false,
              submitting: false,
              error:
                err.response && err.response.data
                  ? err.response.data.result
                  : null
            });
          });
      })
      .catch(err => {
        console.log(err);

        this.setState({
          submitted: false,
          submitting: false,
          error:
            err.response && err.response.data ? err.response.data.result : null
        });
      });
  }

  render() {
    return (
      <div
        className={
          "cell example example1 " +
          (this.state.submitting
            ? "submitting"
            : this.state.submitted
            ? "submitted"
            : "") +
          (this.props.isOpen ? " visible" : "")
        }
        style={{
          paddingTop: !this.props.downloadMode ? 70 : 0,
          paddingBottom: !this.props.downloadMode ? 20 : 0,
          minHeight: !this.props.downloadMode ? 540 : 500
        }}
      >
        <div className="close-modal" onClick={this.props.toggleModal}>
          <i className="fa fa-times"></i>
        </div>
        {!this.props.downloadMode ? (
          <div className="checkout-tabs">
            <div
              className={[
                "tab",
                this.state.activeTab === "shipping" ? "active-tab" : ""
              ].join(" ")}
              onClick={() =>
                this.setState({
                  activeTab: "shipping",
                  pickUp: false
                })
              }
            >
              SHIPPED
            </div>
            <div
              className={[
                "tab",
                this.state.activeTab === "pickup" ? "active-tab" : ""
              ].join(" ")}
              onClick={() =>
                this.setState({
                  activeTab: "pickup",
                  pickUp: true
                })
              }
            >
              PICK-UP
            </div>
          </div>
        ) : null}
        <form onSubmit={e => this.handleSubmit(e)}>
          {this.props.downloadMode ? (
            <fieldset>
              <div className="row">
                <label
                  htmlFor="example1-name"
                  data-tid="elements_examples.form.name_label"
                >
                  Address 1
                </label>
                <input
                  id="example1-name"
                  data-tid="elements_examples.form.name_placeholder"
                  type="address"
                  placeholder="23 Main Street..."
                  onChange={e =>
                    this.setState({
                      address1: e.target.value
                    })
                  }
                  required
                />
              </div>
              <div className="row">
                <label
                  htmlFor="example1-email"
                  data-tid="elements_examples.form.email_label"
                >
                  Address 2
                </label>
                <input
                  id="example1-email"
                  data-tid="elements_examples.form.email_placeholder"
                  type="address"
                  placeholder=""
                  onChange={e =>
                    this.setState({
                      address2: e.target.value
                    })
                  }
                />
              </div>
              <div className="row">
                <label
                  htmlFor="example1-phone"
                  data-tid="elements_examples.form.phone_label"
                >
                  Phone
                </label>
                <input
                  id="example1-phone"
                  data-tid="elements_examples.form.phone_placeholder"
                  type="tel"
                  placeholder="+1 (941) 555-0123"
                  onChange={e =>
                    this.setState({
                      phone: e.target.value
                    })
                  }
                  required
                />
              </div>
            </fieldset>
          ) : this.state.activeTab === "shipping" ? (
            <fieldset>
              <div className="row">
                <label
                  htmlFor="example1-name"
                  data-tid="elements_examples.form.name_label"
                >
                  Address 1
                </label>
                <input
                  id="example1-name"
                  data-tid="elements_examples.form.name_placeholder"
                  type="address"
                  placeholder="23 Main Street..."
                  onChange={e =>
                    this.setState({
                      address1: e.target.value
                    })
                  }
                  required
                />
              </div>
              <div className="row">
                <label
                  htmlFor="example1-email"
                  data-tid="elements_examples.form.email_label"
                >
                  Address 2
                </label>
                <input
                  id="example1-email"
                  data-tid="elements_examples.form.email_placeholder"
                  type="address"
                  placeholder=""
                  onChange={e =>
                    this.setState({
                      address2: e.target.value
                    })
                  }
                />
              </div>
              <div className="row">
                <label
                  htmlFor="example1-phone"
                  data-tid="elements_examples.form.phone_label"
                >
                  Phone
                </label>
                <input
                  id="example1-phone"
                  data-tid="elements_examples.form.phone_placeholder"
                  type="tel"
                  placeholder="+1 (941) 555-0123"
                  onChange={e =>
                    this.setState({
                      phone: e.target.value
                    })
                  }
                  required
                />
              </div>
            </fieldset>
          ) : (
            <fieldset>
              <div className="row">
                <label
                  htmlFor="example1-phone"
                  data-tid="elements_examples.form.phone_label"
                >
                  Phone
                </label>
                <input
                  type="tel"
                  value={this.state.phone}
                  placeholder="+1 (941) 555-0123"
                  onChange={e =>
                    this.setState({
                      phone: e.target.value
                    })
                  }
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="example1-pickup"
                  data-tid="elements_examples.form.pickup_label"
                >
                  Pickup Locations
                </label>
                <div
                  className={[
                    "pickup-location",
                    this.state.pickUpLocation ===
                    "209 E. Ben White Blvd. Suite 111, Austin, TX. 78249"
                      ? "selected"
                      : ""
                  ].join(" ")}
                  onClick={e => {
                    this.setState({
                      pickUpLocation:
                        "209 E. Ben White Blvd. Suite 111, Austin, TX. 78249"
                    });
                  }}
                >
                  <p>
                    Address: 209 E. Ben White Blvd. Suite 111, Austin, TX. 78249
                  </p>
                  <p>Pickup Time: Monday - Friday</p> <p>Pickup Fee: Free</p>
                </div>
                <div className="row pickup-time-row">
                  <input
                    type="tel"
                    value={this.state.pickUpTime}
                    placeholder="When would you like to pick the equipment up?"
                    onChange={e =>
                      this.setState({
                        pickUpTime: e.target.value
                      })
                    }
                    required
                  />
                </div>
                <div
                  className={
                    "error" +
                    (this.state.error && this.state.error.field === "address"
                      ? " visible"
                      : "")
                  }
                  role="alert"
                  style={{
                    position: "static"
                  }}
                >
                  <span className="message">
                    {this.state.error ? this.state.error.message : null}
                  </span>
                </div>
              </div>
            </fieldset>
          )}
          <fieldset>
            <div className="row">
              <div id="example1-card">
                <CardElement
                  ref="card"
                  style={{
                    base: {
                      iconColor: "#42aaff",
                      color: "#868686",
                      fontWeight: 500,
                      fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
                      fontSize: "15px",
                      fontSmoothing: "antialiased",

                      ":-webkit-autofill": {
                        color: "#fce883"
                      },

                      "::placeholder": {
                        color: "rgba(134, 134, 134, 0.4)"
                      }
                    },

                    invalid: {
                      iconColor: "#42aaff",
                      color: "#ff7575"
                    }
                  }}
                />
              </div>
            </div>
            <p className="terms-agreement">
              By clicking the Pay Button you agree to our{" "}
              <Link to="/terms" target="_blank">
                Terms and Conditions of Use.
              </Link>
            </p>
          </fieldset>
          <button type="submit" data-tid="elements_examples.form.pay_button">
            Pay $
            {this.props.downloadMode ? this.props.price : this.props.cartPrice}
          </button>
          {!this.props.downloadMode ? (
            <p class="pay-notice">
              By clicking pay your card will be charged 25% of the total. Once
              the item is returned and the equipment is verified, the rest of
              the money will be charged
            </p>
          ) : null}
          <div
            className={
              "error" +
              (this.state.error && !this.state.error.field ? " visible" : "")
            }
            role="alert"
          >
            <span className="message">
              {this.state.error && !this.state.error.message
                ? this.state.error
                : null}
            </span>
          </div>
        </form>
        <div className="success">
          <div className="icon">
            <svg
              width="84px"
              height="84px"
              viewBox="0 0 84 84"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <circle
                className="border"
                cx="42"
                cy="42"
                r="40"
                strokeLinecap="round"
                strokeWidth="4"
                stroke="#0088cd"
                fill="none"
              />
              <path
                className="checkmark"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M23.375 42.5488281 36.8840688 56.0578969 64.891932 28.0500338"
                strokeWidth="4"
                stroke="#0088cd"
                fill="none"
              />
            </svg>
          </div>
          <h3 className="title" data-tid="elements_examples.success.title">
            Payment successful
          </h3>
          <p className="message">
            {!this.props.downloadMode ? (
              <p data-tid="elements_examples.success.message">
                Thank you for renting from Stareway!
              </p>
            ) : (
              <div>
                <p data-tid="elements_examples.success.message">
                  Thank you for purchasing from Stareway!
                </p>
                <Link to="/account/downloads" className="small-white-btn">
                  DOWNLOAD
                </Link>
              </div>
            )}
          </p>
          {/* <a className="reset" href="#">
            <svg
              width="32px"
              height="32px"
              viewBox="0 0 32 32"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <path
                fill="#0088cd"
                d="M15,7.05492878 C10.5000495,7.55237307 7,11.3674463 7,16 C7,20.9705627 11.0294373,25 16,25 C20.9705627,25 25,20.9705627 25,16 C25,15.3627484 24.4834055,14.8461538 23.8461538,14.8461538 C23.2089022,14.8461538 22.6923077,15.3627484 22.6923077,16 C22.6923077,19.6960595 19.6960595,22.6923077 16,22.6923077 C12.3039405,22.6923077 9.30769231,19.6960595 9.30769231,16 C9.30769231,12.3039405 12.3039405,9.30769231 16,9.30769231 L16,12.0841673 C16,12.1800431 16.0275652,12.2738974 16.0794108,12.354546 C16.2287368,12.5868311 16.5380938,12.6540826 16.7703788,12.5047565 L22.3457501,8.92058924 L22.3457501,8.92058924 C22.4060014,8.88185624 22.4572275,8.83063012 22.4959605,8.7703788 C22.6452866,8.53809377 22.5780351,8.22873685 22.3457501,8.07941076 L22.3457501,8.07941076 L16.7703788,4.49524351 C16.6897301,4.44339794 16.5958758,4.41583275 16.5,4.41583275 C16.2238576,4.41583275 16,4.63969037 16,4.91583275 L16,7 L15,7 L15,7.05492878 Z M16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 Z"
              />
            </svg>
          </a> */}
        </div>
      </div>
    );
  }
}

export default injectStripe(CheckoutForm);



// WEBPACK FOOTER //
// ./src/components/CheckoutForm.js